import { useRegisterSW } from 'virtual:pwa-register/vue';
import { watch } from 'vue';

import { useToast } from '~/components/toast';

/**
 * Surfaces a sticky toast when a fresh service-worker build is ready.
 *
 * vite-plugin-pwa runs in `autoUpdate` mode (see `vite.config.ts`), so the
 * new SW activates as soon as the user accepts. We expose only the action —
 * never auto-reload, because the user might be mid-edit.
 *
 * Call once at app bootstrap (from App.vue).
 */
export function usePwaUpdate(): void {
  const toast = useToast();
  const { needRefresh, updateServiceWorker } = useRegisterSW({
    immediate: true,
    onRegisteredSW(_swUrl, _r) {
      // Could re-check every N minutes for long-lived sessions. Skipping
      // for now — autoUpdate handles the common case on navigation.
    },
    onRegisterError(err) {
      if (import.meta.env.DEV) {
        console.warn('[pwa] register error', err);
      }
    },
  });

  watch(needRefresh, (now) => {
    if (!now) return;
    toast.info({
      title: 'Yeni sürüm hazır',
      description: 'Sayfayı yenileyerek son sürüme geç.',
      duration: 0,
      action: {
        label: 'Yenile',
        onClick: () => {
          void updateServiceWorker(true);
        },
      },
    });
  });
}
